import { useEffect, useState } from 'react';
import { createLoader } from '../../components/phaser/Loader';
import { JButton } from '../../components/UI/JButton';
import Phaser from 'phaser';

interface Props {
  image: string;
  onClose: () => void;
}

export function Pot({ image, onClose }: Props) {
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    setFailed(false);
    let _game: Phaser.Game | undefined;
    try {
      _game = new Phaser.Game({ ...config, parent: 'pot-animation', callbacks: {
        preBoot: game => {
          game.registry.set('rewardImage', image);
          game.registry.set('revealFailed', () => setFailed(true));
        },
      } });
    } catch (error) {
      console.error('Jar reveal failed', error);
      setFailed(true);
    }

    return () => {
      _game?.destroy(true);
    };
  }, [image]);

  return (
    <>
      <div
        id="pot-container"
        style={{
          position: 'absolute',
          top: '30%',
          left: '40%',
          display: 'flex',
          flexDirection: 'column-reverse',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
        }}>
        <JButton onClick={onClose} text="Close" />
        <div id="pot-animation" style={{ width: 333, height: 200, display: failed ? 'none' : undefined }} />
        {failed && <div style={{ width: 333, height: 200, display: 'grid', placeItems: 'center', background: '#263344', color: '#fff' }}>
          <img src={`${process.env.REACT_APP_CDN_PATH ?? ''}${image}`} alt="รางวัลที่ได้รับ" style={{ maxWidth: 120, maxHeight: 120 }} />
          <span>ได้รับรางวัลแล้ว (แอนิเมชันโหลดไม่สำเร็จ)</span>
        </div>}
      </div>
    </>
  );
}

export class Scene extends Phaser.Scene {
  id: number;
  customScale: number;
  onClick: () => void;
  image: string;

  constructor() {
    super({ key: 'pot' });
  }

  init(config: any) {
    this.id = config.id;
    // this.customScale = config.scale;
    this.onClick = config.onClick;
    this.image = config.image || this.registry.get('rewardImage');
  }

  preload() {
    this.load.on('loaderror', () => this.registry.get('revealFailed')?.());
    createLoader(this);

    this.load.setBaseURL(process.env.REACT_APP_CDN_PATH);
    if (process.env.NODE_ENV === 'development') {
      this.load.crossOrigin = 'anonymous';
    }
    this.load.setPath('scenes/arena');
    this.load.multiatlas('pot', 'pot_no_bg.json');
    this.load.multiatlas('bg', 'pot_bg.json');
    this.load.setPath('');
    this.load.image('item', this.image);
  }

  create() {
    if (!this.textures.exists('pot') || !this.textures.exists('bg') || !this.textures.exists('item')) {
      this.registry.get('revealFailed')?.();
      return;
    }
    this.anims.create({
      key: 'pot',
      frameRate: 12,
      frames: this.anims.generateFrameNames(`pot`, {
        start: 0,
        end: this.textures.get(`pot`).frameTotal - 1,
      }),
      repeat: 0,
    });

    this.anims.create({
      key: 'bg',
      frameRate: 12,
      frames: this.anims.generateFrameNames(`bg`, {
        start: 0,
        end: this.textures.get(`bg`).frameTotal - 1,
      }),
      repeat: 0,
    });

    const frame = 21;
    const bg = this.add.sprite(94.55, 58.05, 'bg').setOrigin(0).play('bg');
    this.add.image(bg.getCenter().x, bg.getCenter().y, 'item');
    this.add.sprite(0, 0, 'pot').setOrigin(0).play('pot');

    // const sprite = this.add.sprite(247, 105, 'lever').setOrigin(0).setInteractive({ pixelPerfect: true }).setFrame(1);

    // sprite.on(Phaser.Input.Events.POINTER_OVER, () => {
    //   if (sprite.anims.isPlaying) {
    //     this.input.setDefaultCursor('not-allowed');
    //   } else {
    //     sprite.setTint(0xffbf00);
    //     this.input.setDefaultCursor('pointer');
    //   }
    // });

    // sprite.on(Phaser.Input.Events.POINTER_OUT, () => {
    //   if (!sprite.anims.isPlaying) {
    //     sprite.clearTint();
    //   }
    //   this.input.setDefaultCursor('default');
    // });

    // sprite.on(Phaser.Input.Events.POINTER_DOWN, () => {
    //   if (!sprite.anims.isPlaying) {
    //     this.onClick();
    //     sprite.clearTint();
    //     this.input.setDefaultCursor('not-allowed');
    //   }
    //   sprite.play('lever', true);
    // });

    // sprite.on(Phaser.Animations.Events.SPRITE_ANIMATION_UPDATE, (_: any, frame: Phaser.Animations.AnimationFrame) => {
    //   if (frame.index === 14) {
    //     sprite.setTint(0xaaaaaa);
    //   }
    // });

    // sprite.on(Phaser.Animations.Events.SPRITE_ANIMATION_COMPLETE, () => {
    //   sprite.clearTint();
    // });
  }
}

const config = {
  type: Phaser.CANVAS,
  scene: [Scene],
  transparent: true,
  scale: {
    mode: Phaser.Scale.NONE,
  },
  width: 333,
  height: 200,
};
